import { React, useState,useEffect } from "react";
import "./index.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";
import remove from  "./img/remove.png";


function Landing() {

    useEffect(() => {
        getsession();            
        // fetchapprovaldata();
        }, []);
    const getsession=()=>{
            if(localStorage.getItem('sessions')!=="isactive"){
                window.location.href = "/"
            }

    }
    const redirectTodashboard = ()=>{
        window.location.href = "/PD"
    }
    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    return (
        <div className="bg_set">   
                <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/>         
           
            <div>
        <div>
            <div className="">
            {/* <p className="Headings">Thermal Dashoard</p> */}
            <iframe
                width="100%"
                height="700"
                style={{border:"0"}}
                loading="lazy"
                allowfullscreen
                referrerpolicy="no-referrer-when-downgrade"
                src="http://10.14.14.79:8501/">
                </iframe>
        </div>
        </div> 
            </div>
        
        </div>
    );
}


export default Landing;
